namespace Matrix.DataAudit {
    export class SecurityHistoryColumns {
        static columnsKey = 'DataAudit.SecurityHistory';
    }
}
